import React, { useCallback, useEffect, useState } from 'react';

import { cn } from 'components/lib/utils';
import Typography from 'components/Typography/Typography';


interface ResendSectionProps {
  onResend: () => void | Promise<void>;
  cooldownDurationInSeconds?: number;
  disabled?: boolean;
  className?: string;
}

const ResendSection: React.FC<ResendSectionProps> = ({
  onResend,
  cooldownDurationInSeconds = 30,
  disabled = false,
  className
}) => {
  const [countdown, setCountdown] = useState(0);
  const [isResending, setIsResending] = useState(false);

  useEffect(() => {
    if (countdown > 0) {
      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [countdown]);

  const handleResend = useCallback(async () => {
    setIsResending(true);
    try {
      await onResend();
      setCountdown(cooldownDurationInSeconds);
    } finally {
      setIsResending(false);
    }
  }, [onResend, cooldownDurationInSeconds]);

  const isResendDisabled = disabled || countdown > 0 || isResending;
  
  const getDisabledText = useCallback(() => {
    if (isResending) {
      return 'Resending...';
    }
    if (disabled) {
      return 'Resend code';
    }
    return `Resend code (${countdown}s)`;
  }, [countdown, isResending, disabled]);

  return (
    <div className={cn('text-center', className)}>
      {isResendDisabled ? (
        <Typography className="text-p-s text-base-mutedForeground">
          {getDisabledText()}
        </Typography>
      ) : (
        <Typography
          className="text-p-s text-base-primary cursor-pointer underline"
          onClick={handleResend}
        >
          Resend code
        </Typography>
      )}
    </div>
  );
};

export default ResendSection;



